import React, { useEffect, useState } from 'react'
import About from '../components/About'
import Contact from '../components/Contact'
import Header from '../components/Header'
import NavBar from '../components/NavBar'
import Portfolio from '../components/Portfolio'
import Services from '../components/Services'
import {isAndroid, isMobile, isIOS} from 'react-device-detect'
import Stack from '../components/Stack'
import axios from 'axios'
import { constants } from '../helpers/constants'
import NotificationContext from '../components/toast/NotificationContext'
import { useContext } from 'react'
let deviceMobile = false;


if(isAndroid || isMobile || isIOS){
  deviceMobile = true
}

const Home = () => {

  console.log('renderizando home...')

  const [scrollPosition, setScrollPosition] = useState(0);

  const [activeAbout, setActiveAbout] = useState(false);
  const [activeServices, setActiveServices] = useState(false);
  const [activePortfolio, setActivePortfolio] = useState(false);
  const [activeStack, setActiveStack] = useState(false);
  const [activeContact, setActiveContact] = useState(false);
  const [page, setPage] = useState(null);
  const {showNotification} = useContext(NotificationContext);

  const URL =  constants.test_host +'user/pages/' + constants.user_id+"/"+constants.page_id

  
  useEffect(() => {

    const handleScroll = () => {
   const position = window.pageYOffset;
   setScrollPosition(position);

 };

 window.addEventListener("scroll", handleScroll);

 return () => {
   window.removeEventListener("scroll", {handleScroll})
 };
}, []);

  useEffect(() => {
    getPage();
  }, [])
  
  async function getPage() {
    console.log('llamando al backend...')
    await axios.get(URL, {}, {headers: {
      'Content-Type': 'application/json'
    }}, {withCredentials: true})
    .then((resp)=> {
      console.log(resp)          
      return setPage(resp.data);
    })

    .catch((err) => {
      //showNotification('failed', 'No se pudieron cargar correctamente los datos de la pagina.')
      return
    })
  }


  return (
    <>  
        <NavBar page={page} deviceMobile = {deviceMobile} scrollPosition= {scrollPosition} actives = {{activeAbout, activeServices, activePortfolio, activeContact, activeStack}}  />
        <Header page = {page?.sections} />
        <About setActiveAbout = {setActiveAbout} page={page?.sections} />
        <Services setActiveServices = {setActiveServices} />
        <Portfolio setActivePortfolio = {setActivePortfolio} deviceMobile= {deviceMobile} />
        <Stack setActiveStack = {setActiveStack} />
        <Contact setActiveContact= {setActiveContact} deviceMobile={deviceMobile} />
    </>
  )
}

export default Home